import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Typography, FormHelperText, Container, Button, IconButton, CircularProgress, Paper, Toolbar, Grid, TextField, Divider } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useForm, Controller } from "react-hook-form";
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, TradeActions, NotificationActions } from '../../../store';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import jaLocale from 'date-fns/locale/ja';
import FilterDatePicker from './FilterDatePicker';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px'
    },
    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    table: {
        "& td": {
            paddingRight: '10px'
        }
    },
    transactionDt: {
        textAlign: 'left',
        fontSize: '12px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="&yen;"
            //suffix="円"
        />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const tradesSelector = (state) => state.Trades;
const IdentitySelector = (state) => state.Identity;

const TradeList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const tradeActions = bindActionCreators(TradeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(tradesSelector);
    const { token, userData } = useSelector(IdentitySelector);

    // React Hook Form
    const { control, errors } = useForm();

    const { classes } = props;

    // 検索範囲
    // 取引日時（開始）
    const now = new Date();
    now.setDate(now.getDate() - 1);
    const stDate = now;
    let sdt = stDate.getFullYear()
        + '-' + ('0' + (stDate.getMonth() + 1)).slice(-2)
        + '-' + ('0' + stDate.getDate()).slice(-2)
        + 'T'
        + ('0' + stDate.getHours()).slice(-2)
        + ':' + ('0' + stDate.getMinutes()).slice(-2);
    const [searchStartDt, setSearchStartDt] = React.useState(sdt);
    // 取引日時（終了）
    const enDate = new Date();
    let edt = enDate.getFullYear()
        + '-' + ('0' + (enDate.getMonth() + 1)).slice(-2)
        + '-' + ('0' + enDate.getDate()).slice(-2)
        + 'T'
        + ('0' + enDate.getHours()).slice(-2)
        + ':' + ('0' + enDate.getMinutes()).slice(-2);
    const [searchEndDt, setSearchEndDt] = React.useState(edt);
    // 金額（開始）
    const [searchStartAmount, setSearchStartAmount] = React.useState();
    // 金額（終了）
    const [searchEndAmount, setSearchEndAmount] = React.useState();

    // 加盟店名
    const [searchMerchantName, setSearchMerchantName] = React.useState();
    // 店舗名
    const [searchShopName, setSearchShopName] = React.useState();
    // 取引タイプ
    const [searchTransactionType, setSearchTransactionType] = React.useState();
    // 決済種別
    const [searchAccountType, setSearchAccountType] = React.useState();
    // 決済番号
    const [searchPaymentNo, setSearchPaymentNo] = React.useState();
    // 端末機識別番号
    const [searchTerminalId, setSearchTerminalId] = React.useState();
    // 未了種別
    const [searchUnfinishType, setSearchUnfinishType] = React.useState();

    // 一覧のフィルタリング要素の復元用
    // 2021.02.01 S.Aizawa 非表示化 
    //var _transactionDt = props.transactionDt;           // 取引日時
    //var _merchantName = props.merchantNameSearch;       // 加盟店名
    //var _merchantType = props.merchantType;             // 加盟店タイプ
    //var _shopName = props.shopName;                     // 店舗名
    //var _transactionType = props.transactionType;       // 取引タイプ
    //var _creditAccountType = props.creditAccountType;   // 決済種別(貸方)
    //var _paymentNo = props.paymentNo;                   // 決済番号
    //var _terminalId = props.terminalId;                 // 端末機識別番号
    //var _creditAmount = props.creditAmount;             // 金額(貸方)

    const listDefinition = {
        columns: [
            {
                // 取引日時
                title: <FormattedMessage id="Trade.TransactionDt" />,
                field: 'transaction_dt',
                filterComponent: (props) => (
                    // フィルタリング指定時に日付選択ダイアログを表示して日付を選択
                    <FilterDatePicker
                        columnDef={props.columnDef}
                        onFilterChanged={props.onFilterChanged}
                    />
                ),
                filtering: true,
                defaultFilter: props.transactionDt,
                customFilterAndSearch: (filterValue, rowData) => {
                    // 指定された日付から範囲（0:00:00～23:59:59）を作成
                    //console.log('filterValue:' + filterValue);
                    var dateCheck = new Date(filterValue);
                    var sdt = dateCheck.getFullYear()
                        + '/' + ('0' + (dateCheck.getMonth() + 1)).slice(-2)
                        + '/' + ('0' + dateCheck.getDate()).slice(-2)
                        + ' 00:00:00'
                    var edt = dateCheck.getFullYear()
                        + '/' + ('0' + (dateCheck.getMonth() + 1)).slice(-2)
                        + '/' + ('0' + dateCheck.getDate()).slice(-2)
                        + ' 23:59:59'

                    // レコードの取引日付を判定用フォーマットに変換(yyyy/MM/dd hh:mi:ss)
                    //console.log('transaction_dt:' + rowData.transaction_dt);
                    var transactionDt = new Date(rowData.transaction_dt);
                    var tdt = transactionDt.getFullYear()
                        + '/' + ('0' + (transactionDt.getMonth() + 1)).slice(-2)
                        + '/' + ('0' + transactionDt.getDate()).slice(-2)
                        + ' '
                        + ('0' + transactionDt.getHours()).slice(-2)
                        + ':' + ('0' + transactionDt.getMinutes()).slice(-2)
                        + ':' + ('0' + transactionDt.getSeconds()).slice(-2);

                    //console.log('sdt:' + sdt);
                    //console.log('edt:' + edt);
                    //console.log('tdt:' + tdt);

                    // 指定された日付の分（0:00～23:59）のレコードを表示
                    if (sdt <= tdt && tdt <= edt) {
                        // 範囲内は表示
                        return true;
                    }
                },
                render: rowData => {
                    // 取引日時
                    let transactionDt = new Date(rowData.transaction_dt);
                    //let transactionDtJa = transactionDt.toLocaleString("ja");
                    let tdt = transactionDt.getFullYear()
                        + '/' + ('0' + (transactionDt.getMonth() + 1)).slice(-2)
                        + '/' + ('0' + transactionDt.getDate()).slice(-2)
                        + ' '
                        + ('0' + transactionDt.getHours()).slice(-2)
                        + ':' + ('0' + transactionDt.getMinutes()).slice(-2)
                        + ':' + ('0' + transactionDt.getSeconds()).slice(-2);
                    return (
                        // yyyy/MM/dd hh:mi:ss
                        <Typography className={classes.transactionDt} >{tdt}</Typography>
                    )
                }
            },
            {
                // 加盟店名
                title: <FormattedMessage id="Trade.MerchantName" />,
                field: 'merchant_name',
                filtering: true,
                defaultFilter: props.merchantName,
            },
            // 2021.02.01 S.Aizawa 非表示化 
            //{
            //    // 加盟店タイプ
            //    title: <FormattedMessage id="Trade.MerchantType" />,
            //    field: 'merchant_type',
            //    lookup: {
            //        'acquirer': "代表",
            //        'general': "一般",
            //        '': "",
            //    },
            //    filtering: true,
            //    defaultFilter: props.merchantType,
            //},
            {
                // 店舗名
                title: <FormattedMessage id="Trade.ShopName" />,
                field: 'shop_name',
                filtering: true,
                defaultFilter: props.shopName,
            },
            {
                // 取引タイプ
                title: <FormattedMessage id="Trade.TransactionType" />,
                field: 'transaction_type_name',
                filtering: true,
                defaultFilter: props.transactionTypeName,
            },
            {
                // 口座タイプ(貸方)
                title: <FormattedMessage id="Trade.AccountType" />,
                field: 'credit_account_type',
                lookup: {
                    0: "－",
                    1: "SmartOKICA残高",
                    2: "OKICAカード残額",
                    3: "クレジットカード",
                    4: "銀行口座",
                    5: "OKICAポイント",
                },
                filtering: true,
                defaultFilter: props.creditAccountType,
            },
            {
                // 決済番号
                title: <FormattedMessage id="Trade.PaymentNo" />,
                field: 'payment_no',
                filtering: true,
                defaultFilter: props.payment_no,
            },
            {
                // 端末機識別番号
                title: <FormattedMessage id="Trade.TerminalId" />,
                field: 'terminal_id',
                filtering: true,
                defaultFilter: props.terminalId,
            },
            {
                // 未了
                title: <FormattedMessage id="Trade.Unfinish" />,
                field: 'unfinish_status',
                filtering: true,
                defaultFilter: props.unfinish_status,
            },
            {
                // 未了解消日時
                title: <FormattedMessage id="Trade.UnfinishEliminatedDate" />,
                field: 'eliminated_dt',
                filtering: true,
                defaultFilter: props.eliminated_dt,
            },
            {
                // 金額(貸方)
                title: <FormattedMessage id="Trade.Amount" />,
                field: 'credit_amount',
                type: 'currency',
                currencySetting: { currencyCode:'JPY', minimumFractionDigits:0, maximumFractionDigits:0 },
                filtering: true,
                defaultFilter: props.creditAmount,
            },
        ]
    };

    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
        // 2021.02.01 S.Aizawa 非表示化 
    //const onChangeFilter = (filter) => {

    //    _transactionDt = '';
    //    _merchantName = '';
    //    _merchantType = '';
    //    _shopName = '';
    //    _transactionType = '';
    //    _creditAccountType = '';
    //    _paymentNo = '';
    //    _terminalId = '';
    //    _creditAmount = '';

    //    if (filter.length > 0) {
    //        for (let i = 0; i < filter.length; i++) {
    //            if (filter[i].column.field == 'transaction_dt') {
    //                _transactionDt = filter[i].value;
    //            } else if (filter[i].column.field == 'merchant_name') {
    //                _merchantName = filter[i].value;
    //            } else if (filter[i].column.field == 'merchant_type') {
    //                _merchantType = filter[i].value;
    //            } else if (filter[i].column.field == 'shop_name') {
    //                _shopName = filter[i].value;
    //            } else if (filter[i].column.field == 'transaction_type') {
    //                _transactionType = filter[i].value;
    //            } else if (filter[i].column.field == 'credit_account_type') {
    //                _creditAccountType = filter[i].value;
    //            } else if (filter[i].column.field == 'payment_no') {
    //                _paymentNo = filter[i].value;
    //            } else if (filter[i].column.field == 'terminal_id') {
    //                _terminalId = filter[i].value;
    //            } else if (filter[i].column.field == 'credit_amount') {
    //                _creditAmount = filter[i].value;
    //            }
    //        };
    //    }
    //}

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        if (props.refresh == null || props.refresh == true) {
            // 取引一覧を初期化
            tradeActions.initListInfo();
        }
    }, []);

    /**
     * 
     * 検索ボタン押下時の処理
     * 
     */
    const onSearchClick = () => {
        // 検索条件チェック
        // 検索日時（大小関係）
        if (searchStartDt != "" && searchStartDt != null && searchStartDt != undefined &&
            searchEndDt != "" && searchEndDt != null && searchEndDt != undefined) {
            // UTC変換
            const sdt = new Date(searchStartDt);
            const edt = new Date(searchEndDt);
            if (sdt.getTime() > edt.getTime()) {
                notificationActions.showError("検索条件「取引日時」の大小関係が正しくありません。");
                return;
            }
        }
        // 金額（大小関係）
        if (searchStartAmount != "" && searchStartAmount != null && searchStartAmount != undefined &&
            searchEndAmount != "" && searchEndAmount != null && searchEndAmount != undefined) {
            // 数値変換
            const samount = Number(searchStartAmount);
            const eamount = Number(searchEndAmount);
            if (samount > eamount) {
                notificationActions.showError("検索条件「金額」の大小関係が正しくありません。");
                return;
            }
        }

        // storeに取引リストを要求
        // 取引一覧を取得
        tradeActions.listTrades(token, searchStartDt, searchEndDt, searchStartAmount, searchEndAmount, searchMerchantName, searchShopName, searchTransactionType, searchAccountType, searchPaymentNo, searchTerminalId, searchUnfinishType)
            .then(data => {
                if (data.length == 0) {
                    notificationActions.showInfo("検索条件に該当するレコードがありません。");
                }
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data) => {
        // 選択された行と復元用に変更されたフィルタリング要素を返却
        // 2021.02.01 S.Aizawa 非表示化 
        props.onDetail(data, null, null, null, null, null, null, null, null, null);
        //props.onDetail(data, _transactionDt, _merchantName, _merchantType, _shopName, _transactionType, _creditAccountType, _paymentNo, _terminalId, _creditAmount);
    }

    /**
     * 
     * 結果ダウンロードボタン押下時の処理
     * 
     */
    const onDownloadClick = () => {
        if (list == null || list.length == 0) {
            // メッセージ表示
            notificationActions.showError('データが存在しません。');
            return;
        }

        var nowdt = new Date();
        var timeStr = nowdt.getFullYear()
            + ('0' + (nowdt.getMonth() + 1)).slice(-2)
            + ('0' + nowdt.getDate()).slice(-2)
            + '_'
            + ('0' + nowdt.getHours()).slice(-2)
            + ('0' + nowdt.getMinutes()).slice(-2)
            + ('0' + nowdt.getSeconds()).slice(-2);
        const fileName = `results_${timeStr}.csv`;

        //var headData = '取引ID,取引日時,取引完了日時,加盟店名,加盟店タイプCD,加盟店タイプ,店舗名,取引タイプCD,取引タイプ,勘定科目(借方),決済種別(借方)CD,決済種別(借方),金額(借方),勘定科目(貸方),決済種別(貸方)CD,決済種別(貸方),金額(貸方),摘要欄,決済番号,端末機識別番号,決済代行業者名,GMO仕向け先コード,GMO承認番号,GMOトランザクションID,GMO決済日時,請求書番号,取消取引ID,カード一件明細ID,一件明細IDループカウンタ（カード）,一件明細確定日時（カード）,OKICAカード_一件明細確定日時,ステータスCD,ステータス\r\n'
        var headData = '';
        if (userData.role == 1 || userData.role == 2) {
            headData = '加盟店名,店舗名,取引日時,取引完了日時,取引タイプ,決済種別,金額,決済代行業者名,GMO仕向け先コード,GMO承認番号,GMOトランザクションID,GMO決済日時,端末番号,決済番号,OKICAカード_IDi,OKICAカード_一件明細ID,ステータスCD,ステータス,未了,未了解消日,支払属性,曜日（取引日）\r\n'
        } else {
            headData = '加盟店名,店舗名,取引日時,取引完了日時,取引タイプ,決済種別,金額,端末番号,決済番号,OKICAカード_IDi,未了,未了解消日,支払属性,曜日（取引日）\r\n'
        }
        var csvData = list.map(x => {
            var dtl = [];
            // 加盟店名
            dtl.push(x.merchant_name);
            // 店舗名
            dtl.push(x.shop_name);
            // 取引ID
            //dtl.push(x.id);
            // 取引日時
            var transactionDt = new Date(x.transaction_dt);
            //            var transactionDtStr = transactionDt.toLocaleString("ja");
            let tdt = transactionDt.getFullYear()
                + '/' + ('0' + (transactionDt.getMonth() + 1)).slice(-2)
                + '/' + ('0' + transactionDt.getDate()).slice(-2)
                + ' '
                + ('0' + transactionDt.getHours()).slice(-2)
                + ':' + ('0' + transactionDt.getMinutes()).slice(-2)
                + ':' + ('0' + transactionDt.getSeconds()).slice(-2);
            dtl.push(tdt);
            // 取引完了日時
            var fdt = '';
            if (x.fixed_dt != null) {
                var fixedDt = new Date(x.fixed_dt);
                fdt = fixedDt.getFullYear()
                    + '/' + ('0' + (fixedDt.getMonth() + 1)).slice(-2)
                    + '/' + ('0' + fixedDt.getDate()).slice(-2)
                    + ' '
                    + ('0' + fixedDt.getHours()).slice(-2)
                    + ':' + ('0' + fixedDt.getMinutes()).slice(-2)
                    + ':' + ('0' + fixedDt.getSeconds()).slice(-2);
            }
            //var fixedDt = x.fixed_dt == null?  '' : new Date(x.fixed_dt);
            //var fixedDtStr = fixedDt == ''? '' : fixedDt.toLocaleString("ja");
            dtl.push(fdt);
            // 加盟店タイプ
            //dtl.push(x.merchant_type);
            //var merchantType = '';
            //switch (x.merchant_type) {
            //    case 'acquirer':
            //        merchantType = '代表';
            //        break;
            //    case 'general':
            //        merchantType = '一般';
            //        break;
            //}
            //dtl.push(merchantType);
            // 取引タイプ
            dtl.push(x.transaction_type_name);
            // 勘定科目(借方)
            //            dtl.push(x.debit_title);
            // 決済種別(借方)
            //dtl.push(x.debit_account_type);
            //var debitAccountType = '';
            //switch (x.debit_account_type) {
            //    case 1:
            //        debitAccountType = 'SmartOKICA残高';
            //        break;
            //    case 2:
            //        debitAccountType = 'OKICAカード残額';
            //        break;
            //    case 3:
            //        debitAccountType = 'クレジットカード';
            //        break;
            //    case 4:
            //        debitAccountType = '銀行口座';
            //        break;
            //    case 5:
            //        debitAccountType = 'OKICAポイント';
            //        break;
            //}
            //dtl.push(debitAccountType);
            // 勘定科目(貸方)
            //            dtl.push(x.credit_title);
            // 決済種別(貸方)
            //            dtl.push(x.credit_account_type);
            var creditAccountType = '';
            switch (x.credit_account_type) {
                case 1:
                    creditAccountType = 'SmartOKICA残高';
                    break;
                case 2:
                    creditAccountType = 'OKICAカード残額';
                    break;
                case 3:
                    creditAccountType = 'クレジットカード';
                    break;
                case 4:
                    creditAccountType = '銀行口座';
                    break;
                case 5:
                    creditAccountType = 'OKICAポイント';
                    break;
            }
            dtl.push(creditAccountType);
            // 金額(借方)
            dtl.push(x.debit_amount);
            // 金額(貸方)
            //            dtl.push(x.credit_amount);
            // 摘要欄
            //            dtl.push(x.remarks);
            if (userData.role == 1 || userData.role == 2) {
                // 決済代行業者名
                dtl.push(x.payment_agency_name);
                // GMO仕向け先コード
                dtl.push(x.credit_card_gmo_forward);
                // GMO承認番号
                dtl.push(x.credit_card_gmo_approve);
                // GMOトランザクションID
                dtl.push(x.credit_card_gmo_tran_id);
                // GMO決済日時
                dtl.push(x.credit_card_gmo_tran_date);
            }
            // 端末機識別番号
            dtl.push(x.terminal_id);
            // 決済番号
            dtl.push(x.payment_no);
            // 請求書番号
            //            dtl.push(x.payment_bill_number);
            // 取消取引ID
            //            dtl.push(x.payment_cancel_transaction_id);
            // OKICAカード_IDi
            if (userData.role == 1 || userData.role == 2) {
                dtl.push(x.card_idi);
            } else {
                var idi = ''
                if (x.card_idi != null && x.card_idi.length > 0 && x.card_idi.length <= 17 && x.card_idi.substr(0, 2) == "OK") {
                    var mask = x.card_idi.substr(12, 5);
                    idi = "OK**********" + mask;
                } 
                dtl.push(idi);
            }
            if (userData.role == 1 || userData.role == 2) {
                // OKICAカード_一件明細ID
                dtl.push(x.card_dtl_seq != null ? x.card_dtl_seq : '');
                // OKICAカード_一件明細IDループカウンタ
                //            dtl.push(x.card_dtl_seq_loop_cnt != null ? x.card_dtl_seq_loop_cnt : '');
                // OKICAカード_一件明細確定日時
                //var cardDtlFinishDtStr = '';
                //if (x.card_dtl_finish_dt != null && x.card_dtl_finish_dt != undefined) {
                //    var cardDtlFinishDt = new Date(x.card_dtl_finish_dt);
                //    cardDtlFinishDtStr = cardDtlFinishDt.toLocaleString("ja");
                //}
                //dtl.push(cardDtlFinishDtStr);
                //// ステータス
                dtl.push(x.status);
                var status = '';
                switch (x.status) {
                    case 1:
                        status = '処理中';
                        break;
                    case 2:
                        status = '完了';
                        break;
                    case -1:
                        status = '失敗';
                        break;
                }
                dtl.push(status);
            }

            // 未了フラグ
            dtl.push(x.unfinish_status);
            // 未了解消日時
            dtl.push(x.eliminated_dt);
            // 支払属性
            dtl.push(x.payment_attribute);
            // 曜日（取引日）
            dtl.push(x.day_of_week);

            return dtl.join(',');
        }).join('\r\n');
        let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        let blob = new Blob([bom, headData + csvData], { type: 'text/csv' });
        // 結果ダウンロード用URL作成
        let url = (window.URL || window.webkitURL).createObjectURL(blob);
        // アンカータグを作成
        let link = document.createElement('a');
        link.download = fileName;
        link.href = url;
        document.body.appendChild(link);
        // クリックイベントを発生させる（ダウンロード）
        link.click();
        document.body.removeChild(link);
        // メッセージ表示
        notificationActions.showSuccess(`ダウンロードしました。（${fileName}）`);
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const { name, value } = e[0].target;
        if (name.startsWith('search_start_dt')) {
            setSearchStartDt(value);
        }
        else if (name.startsWith('search_end_dt')) {
            setSearchEndDt(value);
        }
        else if (name.startsWith('search_start_amount')) {
            setSearchStartAmount(value);
        }
        else if (name.startsWith('search_end_amount')) {
            setSearchEndAmount(value);
        }
        else if (name.startsWith('search_merchant_name')) {
            setSearchMerchantName(value);
        }
        else if (name.startsWith('search_shop_name')) {
            setSearchShopName(value);
        }
        else if (name.startsWith('search_transactio_type')) {
            setSearchTransactionType(value);
        }
        else if (name.startsWith('search_account_type')) {
            setSearchAccountType(value);
        }
        else if (name.startsWith('search_payment_no')) {
            setSearchPaymentNo(value);
        }
        else if (name.startsWith('search_terminal_id')) {
            setSearchTerminalId(value);
        }
        else if (name.startsWith('search_unfinish_type')) {
            setSearchUnfinishType(value);
        }
        return value;
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h2" variant="inherit"><FormattedMessage id="Trade.Title" /></Typography>
                                <Typography component="h6">{<FormattedMessage id="Trade.Info" />}</Typography>
                            </div>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={2}>
                                <Controller
                                    name="search_start_dt"
                                    control={control}
                                    onChange={onChange}
                                    as={<TextField fullWidth variant="outlined"
                                        id="search_start_dt"
                                        label={<FormattedMessage id={"Trade.SearchStartDate"} />}
                                        type="datetime-local"
                                        defaultValue={searchStartDt}
                                        className={classes.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Controller
                                    name="search_end_dt"
                                    control={control}
                                    onChange={onChange}
                                    as={<TextField fullWidth variant="outlined"
                                        id="search_end_dt"
                                        label={<FormattedMessage id={"Trade.SearchEndDate"} />}
                                        type="datetime-local"
                                        defaultValue={searchEndDt}
                                        className={classes.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Controller
                                    name="search_start_amount"
                                    control={control}
                                    onChange={onChange}
                                    as={<TextField fullWidth variant="outlined"
                                        id="search_start_amount"
                                        name="search_start_amount"
                                        label={<FormattedMessage id={"Trade.SearchStartAmount"} />}
                                        value={searchStartAmount}
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                    />}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Controller
                                    name="search_end_amount"
                                    control={control}
                                    onChange={onChange}
                                    as={<TextField fullWidth variant="outlined"
                                        id="search_end_amount"
                                        name="search_end_amount"
                                        label={<FormattedMessage id={"Trade.SearchEndAmount"} />}
                                        value={searchEndAmount}
                                        InputProps={{
                                            inputComponent: NumberFormatCustom,
                                        }}
                                    />}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined" error={errors.search_transactio_type && true}>
                                    <InputLabel id="payment-label-cycle"><FormattedMessage id={"Trade.SearchTransactionType"} /></InputLabel>
                                    <Controller
                                        name="search_transactio_type"
                                        control={control}
                                        onChange={onChange}
                                        defaultValue={0}
                                        as={<Select
                                            labelId="search_label_transactio_type"
                                            id="search_transactio_type"
                                            label={<FormattedMessage id={"Trade.SearchTransactionType"} />}>
                                            <MenuItem value={0}>－</MenuItem>
                                            <MenuItem value={1}><FormattedMessage id={"Trade.TransactionType.Fixed"} /></MenuItem>
                                            <MenuItem value={2}><FormattedMessage id={"Trade.TransactionType.Cancel"} /></MenuItem>
                                            <MenuItem value={3}><FormattedMessage id={"Trade.TransactionType.Charge"} /></MenuItem>
                                            <MenuItem value={11}><FormattedMessage id={"Trade.TransactionType.OkiKoro"} /></MenuItem>
                                            <MenuItem value={12}><FormattedMessage id={"Trade.TransactionType.OkiKoroExpiredRecovery"} /></MenuItem>
                                            <MenuItem value={13}><FormattedMessage id={"Trade.TransactionType.OkiKoroUnfinishedRecovery"} /></MenuItem>
                                            <MenuItem value={21}><FormattedMessage id={"Trade.TransactionType.SmaKoro"} /></MenuItem>
                                            <MenuItem value={22}><FormattedMessage id={"Trade.TransactionType.SmaKoroExpiredRecovery"} /></MenuItem>
                                            <MenuItem value={23}><FormattedMessage id={"Trade.TransactionType.SmaKoroUnfinishedRecovery"} /></MenuItem>
                                            <MenuItem value={31}><FormattedMessage id={"Trade.TransactionType.OkiCharge"} /></MenuItem>
                                            <MenuItem value={33}><FormattedMessage id={"Trade.TransactionType.OkiFixed"} /></MenuItem>
                                            <MenuItem value={34}><FormattedMessage id={"Trade.TransactionType.OkiCancel"} /></MenuItem>
                                            <MenuItem value={40}><FormattedMessage id={"Trade.TransactionType.PointReduce"} /></MenuItem>
                                        </Select>} />
                                    <FormHelperText>{errors.payment_cycle ? errors.payment_cycle.message : ""}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined" error={errors.search_unfinish_type && true}>
                                    <InputLabel id="payment-label-cycle"><FormattedMessage id={"Trade.SearchUnfinishType"} /></InputLabel>
                                    <Controller
                                        name="search_unfinish_type"
                                        control={control}
                                        onChange={onChange}
                                        defaultValue={0}
                                        as={<Select
                                            labelId="search_label_unfinish_type"
                                            id="search_unfinish_type"
                                            label={<FormattedMessage id={"Trade.SearchUnfinishType"} />}>
                                            <MenuItem value={0}>－</MenuItem>
                                            <MenuItem value={1}><FormattedMessage id={"Trade.Unfinish.Unfinished"} /></MenuItem>
                                            <MenuItem value={2}><FormattedMessage id={"Trade.Unfinish.Eliminated"} /></MenuItem>
                                            <MenuItem value={3}><FormattedMessage id={"Trade.Unfinish.Failed"} /></MenuItem>
                                            <MenuItem value={4}><FormattedMessage id={"Trade.Unfinish.Finished"} /></MenuItem>
                                        </Select>} />
                                    <FormHelperText>{errors.payment_cycle ? errors.payment_cycle.message : ""}</FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={3}>
                                <Controller
                                    name="search_merchant_name"
                                    control={control}
                                    onChange={onChange}
                                    rules={{
                                        maxLength: { value: 25, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerMerchantNameMaxLenPattern" />}</Typography> }
                                    }}
                                    as={<TextField fullWidth variant="outlined"
                                        error={errors.search_merchant_name && true}
                                        type="text"
                                        helperText={errors.search_merchant_name ? errors.search_merchant_name.message : ""}
                                        label={<FormattedMessage id={"Trade.SearchMerchantName"} />} />} />
                            </Grid>

                            <Grid item xs={2}>
                                <Controller
                                    name="search_shop_name"
                                    control={control}
                                    onChange={onChange}
                                    rules={{
                                        maxLength: { value: 50, message: <FormattedMessage id="Error.ShopName1MaxLenPattern" /> }
                                    }}
                                    as={<TextField fullWidth variant="outlined"
                                        error={errors.search_shop_name && true}
                                        helperText={errors.search_shop_name ? errors.search_shop_name.message : ""}
                                        label={<FormattedMessage id={"Trade.SearchShopName"} />} />} />
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined" error={errors.search_transactio_type && true}>
                                    <InputLabel id="payment-label-cycle"><FormattedMessage id={"Trade.SearchAccountType"} /></InputLabel>
                                    <Controller
                                        name="search_account_type"
                                        control={control}
                                        onChange={onChange}
                                        defaultValue={0}
                                        as={<Select
                                            labelId="search_label_account_type"
                                            id="search_account_type"
                                            label={<FormattedMessage id={"Trade.SearchAccountType"} />}>
                                            <MenuItem value={0}>－</MenuItem>
                                            <MenuItem value={1}><FormattedMessage id={"Trade.AccountType.SmartOKica"} /></MenuItem>
                                            <MenuItem value={2}><FormattedMessage id={"Trade.AccountType.OkicaCard"} /></MenuItem>
                                            <MenuItem value={3}><FormattedMessage id={"Trade.AccountType.CreditCard"} /></MenuItem>
                                            <MenuItem value={4}><FormattedMessage id={"Trade.AccountType.Bank"} /></MenuItem>
                                            <MenuItem value={5}><FormattedMessage id={"Trade.AccountType.OkicaPoint"} /></MenuItem>
                                        </Select>} />
                                    <FormHelperText>{errors.payment_cycle ? errors.payment_cycle.message : ""}</FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid item xs={3}>
                                <Controller
                                    name="search_payment_no"
                                    control={control}
                                    onChange={onChange}
                                    rules={{
                                        maxLength: { value: 25, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerMerchantNameMaxLenPattern" />}</Typography> }
                                    }}
                                    as={<TextField fullWidth variant="outlined"
                                        error={errors.search_payment_no && true}
                                        type="text"
                                        helperText={errors.search_payment_no ? errors.search_payment_no.message : ""}
                                        label={<FormattedMessage id={"Trade.SearchPaymentNo"} />} />} />
                            </Grid>

                            <Grid item xs={2}>
                                <Controller
                                    name="search_terminal_id"
                                    control={control}
                                    onChange={onChange}
                                    rules={{
                                        maxLength: { value:10, message: <FormattedMessage id="Error.ShopName1MaxLenPattern" /> }
                                    }}
                                    as={<TextField fullWidth variant="outlined"
                                        error={errors.search_terminal_id && true}
                                        helperText={errors.search_terminal_id ? errors.search_terminal_id.message : ""}
                                        label={<FormattedMessage id={"Trade.SearchTerminalId"} />} />} />
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <div>
                                    <Button fullWidth id="searchButton" variant="contained" size="medium" color="primary"
                                        startIcon={<SearchIcon />}
                                        onClick={onSearchClick}><FormattedMessage id="Trade.Search" /></Button>
                                </div>
                            </div>
                        </Grid>


                    </Grid>
                </form>
            </Paper>

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={jaLocale}>
                <MaterialTable
                    title={<Typography component="h2" variant="inherit">{<FormattedMessage id="Trade.ResultsTitle" />}</Typography>}
                    // 2021.02.01 S.Aizawa 非表示化 
                    //onFilterChange={(filter) => onChangeFilter(filter)}
                    columns={listDefinition.columns}
                    data={list}
                    options={{
                        search: false,
                        // 2021.02.01 S.Aizawa 非表示化 
                        filtering: false,
                        //filtering: true,
                        actionsColumnIndex: -1
                    }}
                    localization={{
                        body: {
                            emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                        },
                        header: {
                            actions: ''
                        },
                    }}
                    components={{
                        // 右端のアクションボタン列（結果ダウンロードボタン、詳細画面遷移ボタン）
                        Action: actionProps => {
                            if (actionProps.action.tooltip !== "Add") {
                                return (
                                    <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                        <ArrowForwardIosIcon />
                                    </IconButton>
                                )
                            } else {
                                //if (permissions.fid2_0 != null && (permissions.fid2_0.value.value & 2) == 2) {
                                    return (
                                        <Button onClick={() => onDownloadClick()} variant="contained" color="secondary" size="medium" startIcon={<AddCircleOutlineIcon />} >
                                            <FormattedMessage id="Trade.ResultsDownload" />
                                        </Button>
                                    )
                                //}
                                //else {
                                //    return (
                                //        <div></div>
                                //    )
                                //}
                            }
                        }
                    }}
                    editable={{
                        onRowAdd: newData => { },
                        onRowUpdate: (newData, oldData) => { }
                    }}
                />
            </MuiPickersUtilsProvider>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(TradeList);
